import { Button, Grid, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { formStyles } from "./styles";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ENDPOINTS } from "utils/endpoints";
import { POST_API_CALL } from "utils/services";
import ROUTE_NAMES from "routes/routeNames";

export const UserForm = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = (data: Record<string, any>) => {
    // const body: Record<string, any> = {
    //     ...data,
    //     userType: "1",
    //     gender: "0",
    //     password: "Admin@123",
    //     confirmPassword: "Admin@123",
    //     congregationId: 1,
    // };
    const body = {
      userType: "1",
      firstName: "Admin",
      lastName: "S",
      email: "newuser@yopmail.com",
      password: "Admin@123",
      confirmPassword: "Admin@123",
      gender: "0",
      congregationId: 1,
    };
    console.log(body);
    // delete body.congregationName;
    setIsLoading(true);
    POST_API_CALL(ENDPOINTS.USERS.ADD, body, (response: any) => {
      if (response.isSuccess) {
        navigate(ROUTE_NAMES.MAIN_ROUTES.ADD_USERS);
      } else {
        // show error
      }
      setIsLoading(false);
    });
  };
  return (
    <Box>
      <Typography sx={formStyles.heading} variant="h2">
        User Details
      </Typography>
      <Box
        my={3}
        component="form"
        onSubmit={(event) => {
          event.preventDefault();
          const formData = new FormData(event.currentTarget);
          let data: Record<string, any> = {};
          formData.forEach((value, key) => {
            data[key] = value;
          });
          handleSubmit(data);
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              color="secondary"
              name="firstName"
              required
              fullWidth
              id="firstName"
              label="First Name"
              autoFocus
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              color="secondary"
              name="lastName"
              required
              fullWidth
              id="lastName"
              label="Last Name"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              color="secondary"
              required
              fullWidth
              id="email"
              label="Email"
              name="email"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              color="secondary"
              required
              fullWidth
              id="gender"
              label="Brother/Sister"
              name="gender"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              color="secondary"
              name="congregationName"
              required
              fullWidth
              id="congregationName"
              label="Congregation Name"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              color="secondary"
              required
              fullWidth
              id="congregationState"
              label="Congregation State"
              name="congregationState"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              color="secondary"
              required
              fullWidth
              id="city"
              label="Congregation City"
              name="city"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              color="secondary"
              required
              fullWidth
              id="zipCode"
              label="Zipcode"
              name="zipCode"
            />
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" gap={2}>
              <Button
                onClick={() => console.log("handle-click")}
                variant="outlined"
                color="secondary"
                sx={{ mt: 3, mb: 2, width: 200 }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                sx={{ mt: 3, mb: 2, width: 200 }}
              >
                Confirm
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
